import { useNavigate } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export function Breadcrumb({ items }) {
  const navigate = useNavigate();

  return (
    <nav data-testid="breadcrumb" className="flex items-center gap-1 text-sm text-muted-foreground mb-4">
      <button
        onClick={() => navigate("/dashboard")}
        className="hover:text-foreground transition-colors flex items-center gap-1"
        data-testid="breadcrumb-home"
      >
        <Home className="h-3.5 w-3.5" />
      </button>
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center gap-1">
          <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/50" />
          {item.href ? (
            <button
              onClick={() => navigate(item.href)}
              className="hover:text-foreground transition-colors hover:underline"
              data-testid={`breadcrumb-${idx}`}
            >
              {item.label}
            </button>
          ) : (
            <span className="text-foreground font-medium truncate max-w-[200px]" data-testid={`breadcrumb-${idx}`}>
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}
